module.exports = __webpack_public_path__ + "img/down_caret_grey.93ad223d.svg";